import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-area-details-ipm',
  templateUrl: './area-details-ipm.component.html',
  styleUrls: ['./area-details-ipm.component.scss'],
})
export class AreaDetailsIpmComponent {
  @Input() area;
  @Output()
  saveFields = new EventEmitter();
  public showItemList = false;

  showItems() {
    this.showItemList = !this.showItemList;
  }
}
